import axiosInstance from "../../utils/axios"

export async function getPunchlist(value) {
    let res = await axiosInstance.post(`/projects/get_qc_punchlist_internal_and_external`, value)
    return res
}

export async function getReports(value) {
    let res = await axiosInstance.post(`/projects/get_qc_reports`, value)
    return res
}

export async function getQCProgressColor(value) {
    let res = await axiosInstance.get(`/projects/tracker_row_pier_tt_status_wise_color?checklist_type=${value.Scope}&block_id=${value.blockId}&visibility=${value.visibility}`)
    return res
}

export async function getQCPunchlistStatusWiseCounts(value) {
    let res
    if (value?.blockId) {
        res = await axiosInstance.get(`/projects/get_qc_punchlist_status_counts?block_id=${value?.blockId}&scope=${value?.scope}&visibility=${value?.visibility}`)
    }
    else {
        if (value?.scope === "All") {
            res = await axiosInstance.get(`/projects/get_qc_punchlist_status_counts?visibility=${value?.visibility}`)
        }
        else {
            res = await axiosInstance.get(`/projects/get_qc_punchlist_status_counts?scope=${value?.scope}&visibility=${value?.visibility}`)
        }
    }
    return res
}

export async function getDownloadAuditLogs(data) {
    let res = await axiosInstance.post(`/progress-audit/download`, data)
    return res
}
export async function getDownloadITC(data) {
    let res = await axiosInstance.get(`/projects/get_qc_report_upload_id?visibility=${data.visibility}&tracker_row_id=${data.trackerRows[0]}&type=${data.module}`)
    if (res.data) {
        let imageRes = await axiosInstance.get(`/file_upload/download?id=${res?.data?.upload_id}`)
        return imageRes
    }

}
export async function getDownloadReport(value) {
    let res = await axiosInstance.post(`/projects/get_qc_reports`,value)
    return res

}
export async function generateNewITR(data) {

}
export async function updateLockTrackers(data) {
    await axiosInstance.post(`/projects/tracker_row_lock`, data)
}

export async function getLockTrackerDetails(data, visibility, scope) {
    let res = await axiosInstance.get(`/projects/tracker_row_lock?block_id=${data}&scope=${scope}&visibility=${visibility}`)
    return res
}